import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: '/umbraco/api/search/',
    }),
    tagTypes: ['Results'],
    keepUnusedDataFor: 30,
    endpoints(builder) {
        return {
            getSearchResults: builder.query({
                query: (args) => {
                    // Destructuring Object - filterVersion is used for cache invalidation only
                    let { query, types, tags, page, pageSize } = args;
                    return {
                        url: `/results?q=${query}&types=${types}&tags=${tags}&page=${page}&pageSize=${pageSize}`
                    };
                },
               
                serializeQueryArgs: ({ queryArgs }) => {
                    const { query, types, tags, pageSize, filterVersion } = queryArgs;
                    return `${query}-${types}-${tags}-${pageSize}-${filterVersion}`;
                },
                

                // Ai Assist
                forceRefetch({ currentArg, previousArg }) {
                    if (!previousArg) return true;
                    
                    return (
                        currentArg.query !== previousArg.query ||
                        currentArg.types !== previousArg.types ||
                        currentArg.tags !== previousArg.tags ||
                        currentArg.pageSize !== previousArg.pageSize ||
                        currentArg.filterVersion !== previousArg.filterVersion
                    );
                },
                
                // Provide tags for cache invalidation
                providesTags: (result, error, arg) => [
                    { type: 'Results', id: `${arg.query}-${arg.types}-${arg.tags}-${arg.filterVersion}` }
                ],
                
                // Disable cache for filter/search queries to ensure fresh data
                keepUnusedDataFor: 0,
            }),
            getRecombeeSearchResults: builder.query({
                query: (args) => {
                    let { query, count } = args;
                    return {
                        url: `/recombee-results?q=${query}&count=${count}`
                    };
                },
                keepUnusedDataFor: 0,
            }),
        };
    },
});

export const { useGetSearchResultsQuery, useGetRecombeeSearchResultsQuery } = apiSlice;